export default __webpack_public_path__ + "static/media/grow-plants.d6d13770.svg";